import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.string.link";
import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-efd84286");

_pushScopeId("data-v-efd84286");

var _hoisted_1 = {
  class: "title is-4"
};
var _hoisted_2 = {
  class: "subtitle"
};

var _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_4 = {
  class: "card"
};
var _hoisted_5 = {
  key: 0,
  class: "card-image"
};
var _hoisted_6 = {
  class: "image"
};
var _hoisted_7 = {
  class: "bd-snippet bd-is-horizontal bd-is-3"
};
var _hoisted_8 = {
  class: "bd-snippet-preview "
};
var _hoisted_9 = {
  class: "media"
};
var _hoisted_10 = {
  class: "media-left"
};
var _hoisted_11 = {
  key: 0,
  class: "image is-48x48"
};

var _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1);

var _hoisted_13 = {
  class: "level"
};
var _hoisted_14 = {
  class: "level-item"
};
var _hoisted_15 = {
  class: "media-content"
};
var _hoisted_16 = {
  class: "content"
};

var _hoisted_17 = /*#__PURE__*/_createVNode("small", null, " @ ", -1);

var _hoisted_18 = /*#__PURE__*/_createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-external-link-alt"
})], -1);

var _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1);

var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = {
  class: "highlight"
};

var _hoisted_22 = /*#__PURE__*/_createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-plus"
})], -1);

var _hoisted_23 = /*#__PURE__*/_createVNode("p", null, " ", -1);

_popScopeId();

export var render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  return _openBlock(), _createBlock("div", {
    id: "v-projects",
    class: "container",
    alt: _ctx.locale
  }, [_createVNode("h3", _hoisted_1, _toDisplayString(_ctx.t("message.views.projects.title")), 1), _createVNode("h4", _hoisted_2, " ||, +, &, ~, concat() ... " + _toDisplayString(_ctx.t("message.views.projects.subtitle")), 1), _hoisted_3, (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectsEntries, function (project) {
    return _openBlock(), _createBlock("div", {
      key: project.id
    }, [_createVNode("div", _hoisted_4, [_ctx.projectsBanners[project.id] ? (_openBlock(), _createBlock("div", _hoisted_5, [_createVNode("figure", _hoisted_6, [_createVNode("img", {
      src: _ctx.projectsBanners[project.id],
      alt: project.id + ' banner'
    }, null, 8, ["src", "alt"])])])) : _createCommentVNode("", true), _createVNode("div", _hoisted_7, [_createVNode("div", _hoisted_8, [_createVNode("article", _hoisted_9, [_createVNode("div", _hoisted_10, [_ctx.projectsThumbs[project.id] ? (_openBlock(), _createBlock("figure", _hoisted_11, [_createVNode("img", {
      src: _ctx.projectsThumbs[project.id],
      alt: project.id + ' thumb'
    }, null, 8, ["src", "alt"])])) : _createCommentVNode("", true), _hoisted_12, _createVNode("div", _hoisted_13, [_createVNode("div", _hoisted_14, [_createVNode("span", {
      class: "icon is-small",
      title: project.type
    }, [_createVNode("i", {
      class: _ctx.faIcon(project.type)
    }, null, 2)], 8, ["title"])])])]), _createVNode("div", _hoisted_15, [_createVNode("div", _hoisted_16, [_createVNode("p", null, [_createVNode("strong", null, _toDisplayString(project.title[_ctx.locale]), 1), _hoisted_17, _createVNode("small", {
      innerHTML: project.company[_ctx.locale]
    }, null, 8, ["innerHTML"]), project.link ? (_openBlock(), _createBlock("a", {
      key: 0,
      href: project.link,
      target: "_blank"
    }, [_hoisted_18], 8, ["href"])) : _createCommentVNode("", true), _hoisted_19, _createVNode("small", null, _toDisplayString(project.startDate), 1), project.endDate ? (_openBlock(), _createBlock("small", _hoisted_20, " ~ " + _toDisplayString(project.endDate), 1)) : _createCommentVNode("", true)]), _createVNode("p", {
      innerHTML: project.preview[_ctx.locale]
    }, null, 8, ["innerHTML"])])])])]), _createVNode("div", {
      class: ['bd-snippet-code', 'highlight-full', 'bd-is-more', {
        'bd-is-more-clipped': !project.isExpanded
      }]
    }, [_createVNode("figure", _hoisted_21, [_createVNode("pre", {
      class: {
        'has-text-grey-light': !project.isExpanded
      }
    }, "                " + _toDisplayString(project.description[_ctx.locale]) + "\n              ", 3), _createVNode("button", {
      class: "bd-show",
      onClick: function onClick($event) {
        return project.isExpanded = true;
      }
    }, [_createVNode("div", null, [_hoisted_22, _createVNode("strong", null, _toDisplayString(_ctx.t("message.views.projects.showMore")), 1)])], 8, ["onClick"])])], 2)])]), _hoisted_23]);
  }), 128
  /* KEYED_FRAGMENT */
  ))], 8, ["alt"]);
});